import Vue from 'vue';
import VueAnalytics from 'vue-analytics';
import router from '../router';
import { CONSTS } from '@/helpers/consts';

Vue.use(VueAnalytics, {
  id: process.env.NODE_ENV === 'development' ? CONSTS.GA_DEVELOPMENT : CONSTS.GA_PRODUCTION,
  router,
});
